import React from 'react'

export default function Flip() {
  return <svg width="29" height="22" viewBox="0 0 29 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="14.9648" y1="6.55671e-08" x2="14.9648" y2="22" stroke="#BBBBBB" strokeWidth="3" strokeDasharray="4 4"/>
    <path d="M24.2422 7V15.4853L19.9995 11.2426L24.2422 7Z" fill="#BBBBBB"/>
    <path d="M4.24219 7V15.4853L8.48483 11.2426L4.24219 7Z" fill="#BBBBBB"/>
  </svg>
}
